import { render } from "./IconCustomers.vue?vue&type=template&id=63c9a1c6"
import script from "./IconCustomers.vue?vue&type=script&lang=js"
export * from "./IconCustomers.vue?vue&type=script&lang=js"
script.render = render

export default script